/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const gender = useStore((state) => state.gender);
  const setGender = useStore((state) => state.setGender);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.gender.title')}</Title>
        <Text className='description' size='m' medium>
          {t('onboarding.gender.subTitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={gender}
          onChange={(value) => {
            setGender(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'gender',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Male'}>
            <span>👨</span> {t('onboarding.gender.options.male')}
          </Option>
          <Option value={'Female'}>
            <span>👩</span> {t('onboarding.gender.options.female')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
